module.exports = __webpack_public_path__ + "img/filters-page.76af2f7e.png";